var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCCCD9",
    d: "M14.7157 11.7348C15.3655 11.2472 15.9313 10.4625 15.9313 9.20802V9.17591C15.9313 8.37853 15.6636 7.68599 15.1358 7.1175C15.1333 7.11477 15.1307 7.11208 15.1281 7.10944C14.4137 6.38363 13.3447 6 12.0367 6H8.38389C8.17185 6 8 6.17185 8 6.38389V17.6161C8 17.8281 8.17185 18 8.38389 18H12.2369C13.4903 18 14.5529 17.6923 15.3098 17.1101C16.1092 16.4953 16.5317 15.6105 16.5317 14.5514V14.5192C16.5317 13.2609 15.9075 12.3103 14.7157 11.7348ZM12.2677 16.093H9.96879V12.8974H12.0521C12.8939 12.8974 13.5595 13.0489 13.9771 13.3355C14.3506 13.5919 14.5322 13.9528 14.5322 14.439V14.4711C14.5322 15.935 12.9485 16.093 12.2677 16.093ZM11.8356 11.0064H9.96879V7.90703H11.929C13.2017 7.90703 13.9317 8.43385 13.9317 9.35241V9.38449C13.9316 10.7957 12.6184 11.0064 11.8356 11.0064Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.2572d5d18f192d7ec3fba6642039f088.svg";
export { ForwardRef as ReactComponent };